function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M8.16699 13.1667H9.83366V8.16675H8.16699V13.1667ZM9.00032 6.50008C9.23643 6.50008 9.43449 6.42008 9.59449 6.26008C9.75449 6.10008 9.83421 5.9023 9.83366 5.66675C9.83366 5.43064 9.75366 5.23286 9.59366 5.07341C9.43366 4.91397 9.23588 4.83397 9.00032 4.83341C8.76421 4.83341 8.56644 4.91341 8.40699 5.07341C8.24755 5.23341 8.16755 5.43119 8.16699 5.66675C8.16699 5.90286 8.24699 6.10091 8.40699 6.26091C8.56699 6.42091 8.76477 6.50064 9.00032 6.50008ZM9.00032 17.3334C7.84755 17.3334 6.76421 17.1145 5.75033 16.6767C4.73644 16.239 3.85449 15.6454 3.10449 14.8959C2.35449 14.1459 1.76088 13.264 1.32366 12.2501C0.886437 11.2362 0.667548 10.1529 0.666992 9.00008C0.666992 7.8473 0.885881 6.76397 1.32366 5.75008C1.76144 4.73619 2.35505 3.85425 3.10449 3.10425C3.85449 2.35425 4.73644 1.76064 5.75033 1.32341C6.76421 0.886193 7.84755 0.667304 9.00032 0.666748C10.1531 0.666748 11.2364 0.885637 12.2503 1.32341C13.2642 1.76119 14.1462 2.3548 14.8962 3.10425C15.6462 3.85425 16.24 4.73619 16.6778 5.75008C17.1156 6.76397 17.3342 7.8473 17.3337 9.00008C17.3337 10.1529 17.1148 11.2362 16.677 12.2501C16.2392 13.264 15.6456 14.1459 14.8962 14.8959C14.1462 15.6459 13.2642 16.2398 12.2503 16.6776C11.2364 17.1154 10.1531 17.334 9.00032 17.3334Z",
  fill: "#365DE6"
});
const SvgSymbolInfo = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSymbolInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/symbol-info.4d714e2c.svg";
export { ForwardRef as ReactComponent };